<div class="grid">
  <div class="col-12 lg:col-12 md:col-12" style="font-weight: bold; text-align: center; font-size: 16px; margin-bottom: 25px;">
    {{ 'TASASVARIABLES.LBL_APROBACIONPREGUNTA' | translate}}
  </div>
</div>
<div class="grid">
  <div class="col-6 lg:col-6 md:col-6" style="display: flex">
    <div class="col-6 lg:col-6 md:col-6" style="font-weight: bold">
      {{'TASASVARIABLES.LBL_NOMBRETASA' | translate}}
    </div>
    <div class="col-6 lg:col-6 md:col-6">
      {{registro.tasaVariable}}
    </div>
  </div>
  <div class="col-6 lg:col-6 md:col-6" style="display: flex">
    <div class="col-6 lg:col-6 md:col-6" style="font-weight: bold">
      {{'TASASVARIABLES.LBL_DIASVIGENCIA' | translate}}
    </div>
    <div class="col-6 lg:col-6 md:col-6">
      {{registro.diasVigencia}}
    </div>
  </div>
  <div class="col-6 lg:col-6 md:col-6" style="display: flex">
    <div class="col-6 lg:col-6 md:col-6" style="font-weight: bold">
      {{'TASASVARIABLES.LBL_FECHAINICIO' | translate}}
    </div>
    <div class="col-6 lg:col-6 md:col-6">
      {{registro.fechaInicioVigencia | date:'dd/MM/yyyy'}}
    </div>
  </div>
  <div class="col-6 lg:col-6 md:col-6" style="display: flex">
    <div class="col-6 lg:col-6 md:col-6" style="font-weight: bold">
      {{'TASASVARIABLES.LBL_FECHAFIN' | translate}}
    </div>
    <div class="col-6 lg:col-6 md:col-6">
      {{registro.fechaFinVigencia | date:'dd/MM/yyyy'}}
    </div>
  </div>
  <div class="col-6 lg:col-6 md:col-6" style="display: flex">
    <div class="col-6 lg:col-6 md:col-6" style="font-weight: bold">
      {{'TASASVARIABLES.LBL_VALORTASA' | translate}}
    </div>
    <div class="col-6 lg:col-6 md:col-6">
      {{registro.valorTasa}}
    </div>
  </div>
  <div class="col-12 lg:col-12 md:col-12">
    <div class="col-4" style="font-weight: bold">
      <label>{{ "TASASVARIABLES.LBL_OBSERVACIONES" | translate }}</label>
    </div>
    <div class="col-12">
        <input autocomplete="false" [maxlength]="500" pInputText
             [(ngModel)]="observacion" />
    </div>
</div>
<div class="grid form-footer-buttons col-12">
  <div class="form-group col-12">
    <div *ngIf="!guardando" class="gap-2">
      <button icon="fa fa-close" label="Denegar" type="button"
              pButton style="background: red" (click)="salir('DENEGAR')"></button>
      <button icon="fa fa-check" label="Aprobar" type="button"
              pButton (click)="salir('APROBAR')"></button>
    </div>
    <div *ngIf="guardando">
      <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br />
      <span>{{ "LBL_GUARDANDO" | translate }}</span>
    </div>
  </div>
</div>
